import Axios from 'axios'
import { headers } from '../../../../utilities/token'

export const GET_GATEPASS = 'GET_GATEPASS'
export const GET_GATEPASS_FULFILLED = 'GET_GATEPASS_FULFILLED'
export const GET_GATEPASS_REJECTED = 'GET_GATEPASS_REJECTED'

export const POST_GATEPASS = 'POST_GATEPASS'
export const POST_GATEPASS_FULFILLED = 'POST_GATEPASS_FULFILLED'
export const POST_GATEPASS_REJECTED = 'POST_GATEPASS_REJECTED'

export const PUT_GATEPASS = 'PUT_GATEPASS'
export const PUT_GATEPASS_FULFILLED = 'PUT_GATEPASS_FULFILLED'
export const PUT_GATEPASS_REJECTED = 'PUT_GATEPASS_REJECTED'

export const DELETE_GATEPASS = 'DELETE_GATEPASS'
export const DELETE_GATEPASS_FULFILLED = 'DELETE_GATEPASS_FULFILLED'
export const DELETE_GATEPASS_REJECTED = 'DELETE_GATEPASS_REJECTED'

const API_URL = process.env.REACT_APP_API_BASE_URL

export const loadGatePass = (pagination) => {
  return dispatch => {
    dispatch({
      type: GET_GATEPASS,
      payload: {}
    })
    return Axios.get(`${API_URL}/tickets?page=${pagination.page}&limit=${pagination.limit}&searchTerm=${pagination.searchTerm}`, { headers: headers })
      .then(function (response) {
        dispatch({
          type: GET_GATEPASS_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: GET_GATEPASS_REJECTED,
          payload: error
        })
      })
  }
}

export const submitGatePass = (data) => {
  return dispatch => {
    dispatch({
      type: POST_GATEPASS,
      payload: {}
    })
    return Axios.post(`${API_URL}/ticket`, { ...data }, { headers: headers })
      .then(function (response) {
        dispatch({
          type: POST_GATEPASS_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: POST_GATEPASS_REJECTED,
          payload: error
        })
      })
  }
}

export const updateGatePass = (data) => {
  return dispatch => {
    dispatch({
      type: PUT_GATEPASS,
      payload: {}
    })
    return Axios.put(`${API_URL}/ticket/${data.id}`, { ...data }, { headers: headers })
      .then(function (response) {
        return dispatch({
          type: PUT_GATEPASS_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        return dispatch({
          type: PUT_GATEPASS_REJECTED,
          payload: error
        })
      })
  }
}


export const deleteGatePass = (id) => {
  return dispatch => {
    dispatch({
      type: DELETE_GATEPASS,
      payload: {}
    })
    return Axios.delete(`${API_URL}/ticket/${id}`, { headers: headers })
      .then(function (response) {
        return dispatch({
          type: DELETE_GATEPASS_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        return dispatch({
          type: DELETE_GATEPASS_REJECTED,
          payload: error
        })
      })
  }
}











